module.exports = __webpack_public_path__ + "img/15logo.493bf9f7.png";